import { useEffect, useRef, useState } from "react";
import classNames from "classnames";

export default function BankAccountForm({ onSubmit }) {
  const [linkHandler, setLinkHandler] = useState(null);

  useEffect(() => {
    const initialize = () => {
      setLinkHandler(
        Plaid.create({
          env: process.env.PLAID_ENV,
          clientName: "Eventive",
          key: process.env.PLAID_PUBLIC_KEY,
          product: ["auth"],
          selectAccount: true,
          onSuccess: onSubmit,
        })
      );
    };

    if (!document.getElementById("plaid-loader")) {
      const script = document.createElement("script");
      script.id = "plaid-loader";
      script.onload = () => {
        initialize();
      };
      script.src = "https://cdn.plaid.com/link/v2/stable/link-initialize.js";
      document.head.appendChild(script);
    } else {
      initialize();
    }
  }, []);

  return (
    <div
      onClick={() => linkHandler?.open()}
      className={classNames(
        "cursor-pointer inline-flex items-center justify-center px-5 py-2 border border-transparent text-base leading-6 font-medium rounded-md text-white bg-red-600 hover:bg-red-500 focus:outline-none focus:shadow-outline transition duration-150 ease-in-out",
        linkHandler ? "" : "opacity-75 pointer-events-none"
      )}
    >
      {linkHandler ? "Link bank account" : "Loading..."}
    </div>
  );
}
